import { render, staticRenderFns } from "./student_style.vue?vue&type=template&id=7a49e2c1&scoped=true&"
import script from "./student_style.vue?vue&type=script&lang=js&"
export * from "./student_style.vue?vue&type=script&lang=js&"
import style0 from "./student_style.vue?vue&type=style&index=0&id=7a49e2c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a49e2c1",
  null
  
)

export default component.exports